const productData = [
  {
    id: 1,
    slug: "market-table-celebration-crate",
    name: "Market Table Celebration Crate",
    category: "Gift Boxes",
    price: 118,
    image: "/img/products/product-01.png",
    images: ["/img/products/product-01.png"],
    description:
      "A generous spread of creamy cheese, savory charcuterie, crisp crostini, and bright pantry accents, packed for effortless celebrations.",
    attributes: {
      selection: "8 artisan favorites",
      occasion: "Celebrations and thank-yous",
      storage: "Refrigerate perishable items",
    },
    tags: ["giftable", "bestseller", "entertaining"],
    sku: "DZ-GFT-001",
    stock: 36,
    weight: "4.2 lb",
    serves: "6–8",
    badge: "Bestseller",
    featured: true,
    newArrival: false,
    ingredients:
      "Cow's milk cheeses, cured pork, wheat crostini, olives, fruit preserve, and honey.",
  },
  {
    id: 2,
    slug: "after-hours-aperitivo-box",
    name: "After Hours Aperitivo Box",
    category: "Gift Boxes",
    price: 86,
    image: "/img/products/product-02.png",
    images: ["/img/products/product-02.png"],
    description:
      "A lively aperitivo assortment pairing punchy cheeses and cured meats with olives, almonds, and a sweet finish for golden-hour grazing.",
    attributes: {
      selection: "7 cocktail-hour staples",
      occasion: "Host gifts and happy hour",
      storage: "Refrigerate cheese and charcuterie",
    },
    tags: ["aperitivo", "host-gift", "savory"],
    sku: "DZ-GFT-002",
    stock: 42,
    weight: "3.1 lb",
    serves: "4–6",
    badge: "Host Favorite",
    featured: true,
    newArrival: false,
    ingredients:
      "Cow's and sheep's milk cheeses, cured pork, olives, almonds, crackers, and chocolate.",
  },
  {
    id: 3,
    slug: "fireside-cheese-feast",
    name: "Fireside Cheese Feast",
    category: "Gift Boxes",
    price: 142,
    image: "/img/products/product-03.png",
    images: ["/img/products/product-03.png"],
    description:
      "An abundant cold-weather collection of bold alpine cheese, smoky salumi, fig conserve, truffle honey, and sturdy crackers.",
    attributes: {
      selection: "9 fireside pairings",
      occasion: "Holiday tables and weekends away",
      storage: "Refrigerate perishable items",
    },
    tags: ["holiday", "cheese-board", "limited"],
    sku: "DZ-GFT-003",
    stock: 18,
    weight: "4.8 lb",
    serves: "8–10",
    badge: "Limited Batch",
    featured: false,
    newArrival: true,
    ingredients:
      "Cow's milk cheeses, cured pork, wheat crackers, figs, honey, truffle flavor, and hazelnuts.",
  },
  {
    id: 4,
    slug: "little-luxuries-pantry-hamper",
    name: "Little Luxuries Pantry Hamper",
    category: "Gift Boxes",
    price: 72,
    image: "/img/products/product-04.png",
    images: ["/img/products/product-04.png"],
    description:
      "A shelf-stable trove of small-batch olive oil, agrodolce, seasoned nuts, buttery cookies, and dark chocolate for everyday indulgence.",
    attributes: {
      selection: "6 pantry treasures",
      occasion: "Housewarmings and congratulations",
      storage: "Store in a cool, dry place",
    },
    tags: ["pantry", "shelf-stable", "giftable"],
    sku: "DZ-GFT-004",
    stock: 51,
    weight: "3.4 lb",
    serves: "4–6",
    badge: "Easy to Gift",
    featured: true,
    newArrival: true,
    ingredients:
      "Extra virgin olive oil, tomatoes, vinegar, almonds, wheat flour, butter, cocoa, and cane sugar.",
  },
  {
    id: 5,
    slug: "alpine-bloom-reserve",
    name: "Alpine Bloom Reserve",
    category: "Cheese",
    price: 58,
    image: "/img/products/product-05.png",
    images: ["/img/products/product-05.png"],
    description:
      "A supple, cellar-aged wheel with toasted hazelnut depth, a meadow-sweet finish, and enough savory character to anchor any cheese board.",
    attributes: {
      milk: "Raw cow's milk",
      texture: "Firm and crystalline",
      origin: "Vermont, USA",
    },
    tags: ["alpine-style", "nutty", "raw-milk"],
    sku: "DZ-CHS-005",
    stock: 64,
    weight: "8 oz",
    serves: "3–4",
    badge: "Cellar Pick",
    featured: true,
    newArrival: false,
    ingredients: "Raw cow's milk, salt, cultures, and microbial rennet.",
  },
  {
    id: 6,
    slug: "truffle-meadow-brie",
    name: "Truffle Meadow Brie",
    category: "Cheese",
    price: 64,
    image: "/img/products/product-06.png",
    images: ["/img/products/product-06.png"],
    description:
      "A cloud-soft bloomy rind layered with earthy truffle and cultured cream, delivering lush flavor without overpowering the board.",
    attributes: {
      milk: "Pasteurized cow's milk",
      texture: "Soft and creamy",
      origin: "New York, USA",
    },
    tags: ["soft-ripened", "truffle", "creamy"],
    sku: "DZ-CHS-006",
    stock: 29,
    weight: "7 oz",
    serves: "3–4",
    badge: "Staff Favorite",
    featured: true,
    newArrival: false,
    ingredients:
      "Pasteurized cow's milk, cream, salt, cultures, microbial rennet, and black truffle.",
  },
  {
    id: 7,
    slug: "ember-rind-gouda",
    name: "Ember-Rind Gouda",
    category: "Cheese",
    price: 56,
    image: "/img/products/product-07.png",
    images: ["/img/products/product-07.png"],
    description:
      "Slow-aged Gouda with caramelized sweetness, browned-butter richness, and a gently smoky rind that loves dark beer and apple butter.",
    attributes: {
      milk: "Pasteurized cow's milk",
      texture: "Dense and slightly crumbly",
      origin: "Wisconsin, USA",
    },
    tags: ["aged", "smoky", "gouda"],
    sku: "DZ-CHS-007",
    stock: 73,
    weight: "8 oz",
    serves: "3–4",
    badge: null,
    featured: false,
    newArrival: false,
    ingredients:
      "Pasteurized cow's milk, salt, cultures, microbial rennet, and natural smoke.",
  },
  {
    id: 8,
    slug: "lemon-pepper-chevre",
    name: "Lemon Pepper Chèvre",
    category: "Cheese",
    price: 48,
    image: "/img/products/product-08.png",
    images: ["/img/products/product-08.png"],
    description:
      "Fresh goat cheese brightened with lemon zest and cracked pepper for a tangy, spreadable bite made for crostini and crisp vegetables.",
    attributes: {
      milk: "Pasteurized goat's milk",
      texture: "Fresh and spreadable",
      origin: "Pennsylvania, USA",
    },
    tags: ["fresh-cheese", "citrus", "vegetarian"],
    sku: "DZ-CHS-008",
    stock: 47,
    weight: "6 oz",
    serves: "2–3",
    badge: "New",
    featured: false,
    newArrival: true,
    ingredients:
      "Pasteurized goat's milk, salt, cultures, lemon zest, black pepper, and microbial rennet.",
  },
  {
    id: 9,
    slug: "heritage-fennel-salami",
    name: "Heritage Fennel Salami",
    category: "Charcuterie",
    price: 52,
    image: "/img/products/product-09.png",
    images: ["/img/products/product-09.png"],
    description:
      "A dry-cured salami scented with toasted fennel seed and garlic, balancing rustic pork flavor with a clean, lingering finish.",
    attributes: {
      protein: "Heritage-breed pork",
      cure: "Dry cured for 45 days",
      origin: "Pennsylvania, USA",
    },
    tags: ["salami", "fennel", "gluten-free"],
    sku: "DZ-CHR-009",
    stock: 82,
    weight: "6 oz",
    serves: "3–4",
    badge: "Bestseller",
    featured: true,
    newArrival: false,
    ingredients:
      "Pork, sea salt, fennel seed, garlic, dextrose, spices, and cultured celery powder.",
  },
  {
    id: 10,
    slug: "black-pepper-coppa",
    name: "Black Pepper Coppa",
    category: "Charcuterie",
    price: 59,
    image: "/img/products/product-10.png",
    images: ["/img/products/product-10.png"],
    description:
      "Silky ribbons of cured pork shoulder with a fragrant black-pepper crust and a deep, wine-friendly savor.",
    attributes: {
      protein: "Pork shoulder",
      cure: "Whole-muscle cured",
      origin: "Virginia, USA",
    },
    tags: ["whole-muscle", "peppery", "gluten-free"],
    sku: "DZ-CHR-010",
    stock: 45,
    weight: "4 oz",
    serves: "2–3",
    badge: "Butcher's Pick",
    featured: true,
    newArrival: false,
    ingredients: "Pork, sea salt, black pepper, cane sugar, and spices.",
  },
  {
    id: 11,
    slug: "cherrywood-smoked-speck",
    name: "Cherrywood Smoked Speck",
    category: "Charcuterie",
    price: 62,
    image: "/img/products/product-11.png",
    images: ["/img/products/product-11.png"],
    description:
      "Delicately smoked and patiently cured ham with rosy marbling, mountain-herb aromatics, and a whisper of cherrywood sweetness.",
    attributes: {
      protein: "Pork leg",
      cure: "Smoked and air dried",
      origin: "Colorado, USA",
    },
    tags: ["smoked", "whole-muscle", "limited"],
    sku: "DZ-CHR-011",
    stock: 24,
    weight: "4 oz",
    serves: "2–3",
    badge: "Limited Batch",
    featured: false,
    newArrival: true,
    ingredients: "Pork, sea salt, cane sugar, juniper, herbs, and natural smoke.",
  },
  {
    id: 12,
    slug: "calabrian-citrus-soppressata",
    name: "Calabrian Citrus Soppressata",
    category: "Charcuterie",
    price: 54,
    image: "/img/products/product-12.png",
    images: ["/img/products/product-12.png"],
    description:
      "Coarse-cut soppressata energized by Calabrian chile and orange peel, with mellow heat that builds beautifully between bites.",
    attributes: {
      protein: "Humanely raised pork",
      cure: "Dry cured for 40 days",
      origin: "New Jersey, USA",
    },
    tags: ["spicy", "citrus", "salami"],
    sku: "DZ-CHR-012",
    stock: 58,
    weight: "6 oz",
    serves: "3–4",
    badge: "New",
    featured: false,
    newArrival: true,
    ingredients:
      "Pork, sea salt, Calabrian chile, orange peel, garlic, dextrose, and cultured celery powder.",
  },
  {
    id: 13,
    slug: "roasted-tomato-agrodolce",
    name: "Roasted Tomato Agrodolce",
    category: "Pantry",
    price: 45,
    image: "/img/products/product-13.png",
    images: ["/img/products/product-13.png"],
    description:
      "Slow-roasted tomatoes sharpened with vinegar and softened with cane sugar, ready to spoon over cheese, grilled bread, or roast chicken.",
    attributes: {
      format: "Small-batch preserve",
      flavor: "Sweet, tangy, and savory",
      origin: "Philadelphia, USA",
    },
    tags: ["condiment", "vegetarian", "small-batch"],
    sku: "DZ-PAN-013",
    stock: 91,
    weight: "9 oz",
    serves: "8–10",
    badge: "House Recipe",
    featured: true,
    newArrival: false,
    ingredients:
      "Tomatoes, cane sugar, red wine vinegar, extra virgin olive oil, garlic, sea salt, and herbs.",
  },
  {
    id: 14,
    slug: "porcini-truffle-honey",
    name: "Porcini Truffle Honey",
    category: "Pantry",
    price: 49,
    image: "/img/products/product-14.png",
    images: ["/img/products/product-14.png"],
    description:
      "Wildflower honey infused with porcini and black truffle for a woodsy drizzle that transforms blue cheese, pizza, and roasted squash.",
    attributes: {
      format: "Infused wildflower honey",
      flavor: "Earthy and floral",
      origin: "New York, USA",
    },
    tags: ["honey", "truffle", "cheese-pairing"],
    sku: "DZ-PAN-014",
    stock: 67,
    weight: "7 oz",
    serves: "10–12",
    badge: "Pairing Essential",
    featured: true,
    newArrival: false,
    ingredients:
      "Wildflower honey, dried porcini mushroom, and natural black truffle flavor.",
  },
  {
    id: 15,
    slug: "sicilian-lemon-olive-oil",
    name: "Sicilian Lemon Olive Oil",
    category: "Pantry",
    price: 68,
    image: "/img/products/product-15.png",
    images: ["/img/products/product-15.png"],
    description:
      "Early-harvest olives and whole lemons are crushed together for a vivid oil with peppery structure and true citrus perfume.",
    attributes: {
      format: "Whole-fruit agrumato oil",
      flavor: "Bright, grassy, and peppery",
      origin: "Sicily, Italy",
    },
    tags: ["olive-oil", "imported", "vegan"],
    sku: "DZ-PAN-015",
    stock: 54,
    weight: "16.9 fl oz",
    serves: "20+",
    badge: "Just In",
    featured: false,
    newArrival: true,
    ingredients: "Extra virgin olive oil and fresh lemons.",
  },
  {
    id: 16,
    slug: "rosemary-sea-salt-crostini",
    name: "Rosemary Sea Salt Crostini",
    category: "Pantry",
    price: 45,
    image: "/img/products/product-16.png",
    images: ["/img/products/product-16.png"],
    description:
      "Thin, golden crostini baked with olive oil, rosemary, and flaky sea salt for an exceptionally crisp cheese-board companion.",
    attributes: {
      format: "Twice-baked crostini",
      flavor: "Herbaceous and savory",
      origin: "Pennsylvania, USA",
    },
    tags: ["crackers", "vegan", "entertaining"],
    sku: "DZ-PAN-016",
    stock: 114,
    weight: "6.5 oz",
    serves: "6–8",
    badge: null,
    featured: false,
    newArrival: false,
    ingredients:
      "Wheat flour, water, extra virgin olive oil, yeast, rosemary, sea salt, and malted barley flour.",
  },
  {
    id: 17,
    slug: "dark-chocolate-fig-salami",
    name: "Dark Chocolate Fig Salami",
    category: "Sweets",
    price: 52,
    image: "/img/products/product-17.png",
    images: ["/img/products/product-17.png"],
    description:
      "A sliceable confection of dark chocolate, figs, toasted hazelnuts, and crisp biscuit pieces finished with a snowy sugar dusting.",
    attributes: {
      cocoa: "70% dark chocolate",
      texture: "Fudgy with a crisp crunch",
      origin: "Philadelphia, USA",
    },
    tags: ["chocolate", "fig", "giftable"],
    sku: "DZ-SWT-017",
    stock: 77,
    weight: "7 oz",
    serves: "6–8",
    badge: "Bestseller",
    featured: true,
    newArrival: false,
    ingredients:
      "Dark chocolate, dried figs, hazelnuts, wheat biscuits, butter, cane sugar, and cocoa powder.",
  },
  {
    id: 18,
    slug: "pistachio-torrone-bites",
    name: "Pistachio Torrone Bites",
    category: "Sweets",
    price: 48,
    image: "/img/products/product-18.png",
    images: ["/img/products/product-18.png"],
    description:
      "Tender honey nougat packed with roasted pistachios and cut into shareable bites with a delicate orange-blossom finish.",
    attributes: {
      style: "Soft Italian-style nougat",
      texture: "Tender and nutty",
      origin: "New Jersey, USA",
    },
    tags: ["nougat", "pistachio", "gluten-free"],
    sku: "DZ-SWT-018",
    stock: 63,
    weight: "6 oz",
    serves: "5–6",
    badge: null,
    featured: false,
    newArrival: false,
    ingredients:
      "Honey, cane sugar, pistachios, egg whites, orange blossom water, and sea salt.",
  },
  {
    id: 19,
    slug: "salted-espresso-caramels",
    name: "Salted Espresso Caramels",
    category: "Sweets",
    price: 49,
    image: "/img/products/product-19.png",
    images: ["/img/products/product-19.png"],
    description:
      "Soft, slow-cooked caramels layered with roasted espresso and flaky salt for a balanced bittersweet finish.",
    attributes: {
      style: "Individually wrapped caramels",
      texture: "Soft and chewy",
      origin: "Pennsylvania, USA",
    },
    tags: ["caramel", "coffee", "small-batch"],
    sku: "DZ-SWT-019",
    stock: 88,
    weight: "5.5 oz",
    serves: "10–12",
    badge: "Small Batch",
    featured: true,
    newArrival: false,
    ingredients:
      "Cane sugar, cream, butter, corn syrup, espresso, vanilla, and sea salt.",
  },
  {
    id: 20,
    slug: "amarena-cherry-butter-cookies",
    name: "Amarena Cherry Butter Cookies",
    category: "Sweets",
    price: 46,
    image: "/img/products/product-20.png",
    images: ["/img/products/product-20.png"],
    description:
      "Crumbly cultured-butter cookies studded with tart Amarena cherries and finished with a hint of almond.",
    attributes: {
      style: "Shortbread cookie",
      texture: "Crisp and buttery",
      origin: "Philadelphia, USA",
    },
    tags: ["cookies", "cherry", "tea-time"],
    sku: "DZ-SWT-020",
    stock: 74,
    weight: "7 oz",
    serves: "6–8",
    badge: "New",
    featured: false,
    newArrival: true,
    ingredients:
      "Wheat flour, cultured butter, cane sugar, Amarena cherries, almonds, vanilla, and sea salt.",
  },
  {
    id: 21,
    slug: "cheese-cellar-collection",
    name: "Cheese Cellar Collection",
    category: "Clubs",
    price: 89,
    image: "/img/products/product-21.png",
    images: ["/img/products/product-21.png"],
    description:
      "Three peak-season cheeses selected by our mongers, complete with tasting notes, pairing ideas, and a pantry surprise.",
    attributes: {
      selection: "3 cheeses plus 1 pairing",
      format: "One-time collection",
      storage: "Refrigerate on arrival",
    },
    tags: ["cheese", "giftable", "collection"],
    sku: "DZ-CLB-021",
    stock: 250,
    weight: "Approx. 2.5 lb",
    serves: "6–8",
    badge: "Most Popular",
    featured: true,
    newArrival: false,
    ingredients: "Selections vary; allergen details are included with every collection.",
  },
  {
    id: 22,
    slug: "aperitivo-society-club",
    name: "Aperitivo Society Club",
    category: "Clubs",
    price: 96,
    image: "/img/products/product-22.png",
    images: ["/img/products/product-22.png"],
    description:
      "A generous spread of cheese, charcuterie, and bold cocktail-hour accompaniments curated for instant entertaining.",
    attributes: {
      selection: "5–6 aperitivo favorites",
      format: "One-time collection",
      storage: "Refrigerate perishables",
    },
    tags: ["charcuterie", "entertaining", "collection"],
    sku: "DZ-CLB-022",
    stock: 180,
    weight: "Approx. 3 lb",
    serves: "6–8",
    badge: "Party Ready",
    featured: true,
    newArrival: false,
    ingredients: "Selections vary; allergen details are included with every collection.",
  },
  {
    id: 23,
    slug: "pantry-passport-club",
    name: "Pantry Passport Club",
    category: "Clubs",
    price: 78,
    image: "/img/products/product-23.png",
    images: ["/img/products/product-23.png"],
    description:
      "A curated journey through exceptional oils, preserves, pasta-night essentials, and table-ready discoveries from independent makers.",
    attributes: {
      selection: "4–5 shelf-stable finds",
      format: "One-time collection",
      storage: "Store in a cool, dry place",
    },
    tags: ["pantry", "discovery", "collection"],
    sku: "DZ-CLB-023",
    stock: 220,
    weight: "Approx. 4 lb",
    serves: "Varies by selection",
    badge: "New Collection",
    featured: false,
    newArrival: true,
    ingredients: "Selections vary; allergen details are included with every collection.",
  },
  {
    id: 24,
    slug: "sweet-table-club",
    name: "Sweet Table Club",
    category: "Clubs",
    price: 69,
    image: "/img/products/product-24.png",
    images: ["/img/products/product-24.png"],
    description:
      "Four joyful sweets—from bean-to-bar chocolate to tender nougat and bakery treats—chosen for gifting or keeping.",
    attributes: {
      selection: "4 artisan sweets",
      format: "One-time collection",
      storage: "Store in a cool, dry place",
    },
    tags: ["sweets", "giftable", "collection"],
    sku: "DZ-CLB-024",
    stock: 200,
    weight: "Approx. 2 lb",
    serves: "8–10",
    badge: "Sweetest Delivery",
    featured: false,
    newArrival: true,
    ingredients: "Selections vary; allergen details are included with every collection.",
  },
  {
    id: 25,
    slug: "golden-orchard-pairing-box",
    name: "Golden Orchard Pairing Box",
    category: "Gift Boxes",
    price: 64,
    image: "/img/products/product-25.png",
    images: ["/img/products/product-25.png"],
    description:
      "A warm, gift-ready pairing of creamy cheese, crisp seeded crackers, amber honey, dried pear, and roasted almonds.",
    attributes: {
      selection: "5 orchard-inspired favorites",
      occasion: "Thank-yous and relaxed gatherings",
      storage: "Refrigerate cheese on arrival",
    },
    tags: ["giftable", "cheese-pairing", "orchard"],
    sku: "DZ-GFT-025",
    stock: 44,
    weight: "2.6 lb",
    serves: "4–6",
    badge: "New",
    featured: false,
    newArrival: true,
    ingredients:
      "Cow's milk cheese, wheat and seed crackers, wildflower honey, dried pears, roasted almonds, and sea salt.",
  },
];

export default productData;
